export default {
  endpoint: 'wss://suggest.market.envato.com/socket',
  channel: 'autocomplete:standard'
}
